import { WarningModalContext } from '../enums/warning-modal-context.enum';
import { TranslationsHelper } from './translations-helper';

export class WarningModalMessageHelper {
	public static Contexts = [
		{description: 'Entering CSP', id: WarningModalContext.EnterCsp, translations: {source: TranslationsHelper.cspSourceTranslations, target: TranslationsHelper.cspTargetTranslations}},
		{description: 'Entering CSP-FS', id: WarningModalContext.EnterCspfs, translations: {source: TranslationsHelper.cspfsSourceTranslations, target: TranslationsHelper.cspfsTargetTranslations}},
		{description: 'Product Pricing Conflict', id: WarningModalContext.ProductPricingConflict, translations: {source: TranslationsHelper.cspSourceTranslations, target: TranslationsHelper.cspTargetTranslations}}];
}
